/**
 * Supported platforms for key normalization.
 */
export enum Platform {
    Apple = "apple",
    PC = "pc"
}
